var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-detail" }, [
    _c("div", { staticClass: "order-header" }, [
      _c("div", { staticClass: "order-info" }, [
        _c("span", { staticClass: "order-title" }, [
          _vm._v("订单号：" + _vm._s(_vm.orderData.orderNo || "200021111")),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order-actions" },
        [
          _c("el-button", { attrs: { type: "warning", size: "small" } }, [
            _vm._v("上个订单"),
          ]),
          _vm._v(" "),
          _c("el-button", { attrs: { type: "warning", size: "small" } }, [
            _vm._v("下个订单"),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info-section" }, [
      _c("div", { staticClass: "buyer-info" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("购买人信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-form" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("订单号：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(
                    _vm.buyerInfo.orderNo ||
                      _vm.orderData.orderNo ||
                      "200021111"
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("付款的店：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(_vm.buyerInfo.paymentStore || "gaga蜂语（测试门店）")
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("下单时间：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.buyerInfo.orderTime || "2025-08-07 01:49")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("支付方式：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.buyerInfo.paymentMethod || "微信支付")),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "package-info" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("包装信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-form" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("包装：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.packageInfo.package || "外卖袋")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("套餐：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.packageInfo.setMeal || "标准套餐")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("套餐价编辑：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.packageInfo.setMealEdit || "无")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("备注：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.packageInfo.note || "无特殊要求")),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info-section" }, [
      _c("div", { staticClass: "receiver-info" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("收货人信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-form" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("收货人：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.receiverInfo.receiver || "张三")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("手机：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.receiverInfo.phone || "15188241230")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item full-width" }, [
              _c("span", { staticClass: "label" }, [_vm._v("地址：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(
                    _vm.receiverInfo.address || "广东省深圳市南山区科技园南区"
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "delivery-info" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("发货信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "info-form" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("发货单：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(_vm.deliveryInfo.deliveryOrder || "D20250807001")
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item" }, [
              _c("span", { staticClass: "label" }, [_vm._v("发货时间：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(_vm.deliveryInfo.deliveryTime || "2025-08-07 02:30")
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-item full-width" }, [
              _c("span", { staticClass: "label" }, [_vm._v("骑手信息：")]),
              _vm._v(" "),
              _c("span", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(_vm.deliveryInfo.riderInfo || "李师傅 - 13800138000")
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "product-section" },
      [
        _c("div", { staticClass: "section-title" }, [_vm._v("商品信息")]),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.productData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "image",
                label: "图片",
                align: "center",
                width: "80",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.image
                        ? _c("el-image", {
                            staticStyle: { width: "40px", height: "40px" },
                            attrs: { src: scope.row.image, fit: "cover" },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "marketPrice", label: "市场价", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "unitPrice", label: "单价", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "discount", label: "折扣", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "addPrice", label: "加价", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "quantity", label: "数量", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "method", label: "做法", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "refundStatus",
                label: "退货状态",
                align: "center",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "coupon-section" },
      [
        _c("div", { staticClass: "section-title" }, [_vm._v("优惠券信息")]),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.couponData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "type", label: "券号", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "couponCode", label: "券码编码", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "category", label: "券类型", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "券名称", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "value", label: "券面值", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "price", label: "券运价格", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "useCount", label: "使用张数", align: "center" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "meituan-coupon-section" },
      [
        _c("div", { staticClass: "section-title" }, [_vm._v("美团优惠券信息")]),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.meituanCouponData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "no", label: "券号", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "code", label: "美团券码", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "type", label: "券类型", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "券名称", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "value", label: "券面值", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "price", label: "券运价格", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "useCount", label: "使用张数", align: "center" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "cost-section" }, [
      _c("div", { staticClass: "section-title" }, [_vm._v("费用信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-form" }, [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("商品总金额：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.costInfo.productTotal || "¥32.00")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("折扣：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.costInfo.discount || "¥0.00")),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("配送费用：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.costInfo.deliveryFee || "¥2.10")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "label" }, [_vm._v("应付款金额：")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.costInfo.payableAmount || "¥34.10")),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "form-item full-width" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v("已付款金额(含商品优惠)："),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.costInfo.paidAmount || "¥34.10")),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "operation-section" }, [
      _c("div", { staticClass: "section-title" }, [_vm._v("操作信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "info-form" }, [
        _c("div", { staticClass: "form-row" }, [
          _c(
            "div",
            { staticClass: "form-item full-width" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("操作备注：")]),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { flex: "1" },
                attrs: {
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入操作备注",
                  resize: "none",
                },
                model: {
                  value: _vm.operationInfo.operationNote,
                  callback: function ($$v) {
                    _vm.$set(_vm.operationInfo, "operationNote", $$v)
                  },
                  expression: "operationInfo.operationNote",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "form-item full-width" }, [
            _c("span", { staticClass: "label" }, [_vm._v("可执行操作：")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "operation-buttons" },
              [
                _c("el-button", { attrs: { type: "info", size: "small" } }, [
                  _vm._v("取消"),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "small" },
                    on: { click: _vm.handleRemove },
                  },
                  [_vm._v("移除")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "small" },
                    on: { click: _vm.handleGenerateMenu },
                  },
                  [_vm._v("生成发货单")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleAddNote },
                  },
                  [_vm._v("备注")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "status-section" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.statusData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "operator", label: "操作人", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "operateTime",
                label: "操作时间",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "orderStatus",
                label: "订单状态",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "paymentStatus",
                label: "付款状态",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "deliveryStatus",
                label: "发货状态",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "note", label: "备注", align: "center" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }